export function combineStr (obj) {
  let str = "";
  for (let key in obj) {
    str += "&" + key + "=" + obj[key]
  }
  return str
}



// WEBPACK FOOTER //
// ./src/lib/resourcePageUtils.js